'use client';

import Image from 'next/image';
import {
  Bell,
  Briefcase,
  ChevronDown,
  CreditCard,
  DollarSign,
  FileText,
  HelpCircleIcon,
  Lock,
  MessageSquareMore,
  NewspaperIcon,
  Phone,
  Shield,
  ShoppingBag,
  Upload,
} from 'lucide-react';
import { useRouter } from 'next/navigation';
import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { Avatar, Box, IconButton, Modal, Tooltip } from '@mui/material';
import { Button } from '@mui/material';
import { getSessionStorageItem } from '@/lib/storage';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess, setLoading } from '@/redux/slice/authSlice';
import { RootState } from '@/redux/store';
import { allLanguages } from '@/app/static/language';
import { FisrtloginStyle } from '../ModalStyle/ModalStyle';
import FirstLoginModal from '../FirstLoginModal/FirstLoginModal';
export default function BlackHeader() {
  const [open, setOpen] = React.useState(true);
  const handleClose = () => setOpen(false);
  const style = {
    position: 'absolute',
    top: '45%',
    left: '50%',
    background: 'linear-gradient(rgb(38, 35, 87), black)',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    bgcolor: 'background.paper',
    boxShadow: 24,
  };
  const boxRef = useRef<HTMLDivElement>(null);

  const handleCloseModal = (event: any, reason: string) => {
    if (reason === 'backdropClick' && boxRef.current !== null) {
      // Add outline for a "bump" effect
      boxRef.current.style.outline = '1px solid white';

      // Remove the outline after 300ms (bump effect duration)
      setTimeout(() => {
        if (boxRef.current) {
          boxRef.current.style.outline = 'none';
        }
      }, 100);
    }
  };

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const router = useRouter();

  useEffect(() => {
    const token: any = getSessionStorageItem('token');
    const accountType: any = getSessionStorageItem('WhoAmI');
    const user: any = getSessionStorageItem('user');
    const data: any = getSessionStorageItem('data');

    if (
      token !== null &&
      token !== undefined &&
      accountType !== null &&
      accountType !== undefined &&
      user !== null &&
      user !== undefined
    ) {
      dispatch(
        loginSuccess({
          token: token,
          user: user,
          isAuthenticated: true,
          accountType: accountType,
          data: data,
        }),
      );
      setIsUserLoggedIn(true);
    }
    dispatch(setLoading(false));
  }, []);

  const [openLoginModal, setOpenLoginModal] = React.useState(false);
  const handleLoginOpen = (url: string) => {
    if (isUserLoggedIn) {
      router.push(url);
    } else {
      setOpenLoginModal(true);
    }
  };

  const handleLoginClose = () => setOpenLoginModal(false);
  const loginStyle = FisrtloginStyle;

  const handleProfileAvtarClick = () => {
    const WhoAmI = getSessionStorageItem('WhoAmI');
    if (WhoAmI === 'partial') {
      router.push('/profile');
      return;
    }
    router.push('/profile/pin');
  };

  const handleCreateClick = () => {
    router.push('/partial-option-landing'); // Redirect to login page if not authenticated
  };
  const handleOkClick = () => {
    router.push('/login-landing'); // Redirect to login page if not authenticated
  };

  const [productMenuOpen, setProductMenuOpen] = useState(false);
  const [resourceMenuOpen, setResourceMenuOpen] = useState(false);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const productMenuRef = useRef(null);
  const resourceMenuRef = useRef(null);
  const languageMenuRef = useRef(null);

  const handleMouseLeave = (
    menuSetter: React.Dispatch<React.SetStateAction<boolean>>,
    ref: MutableRefObject<HTMLElement | null>,
  ) => {
    setTimeout(() => {
      if (!ref?.current?.matches(':hover')) {
        menuSetter(false);
      }
    }, 200);
  };
  const languages: any = allLanguages;

  return (
    <>
      {/* On mount modal */}
      <Modal
        open={open}
        onClose={(event, reason) => handleCloseModal(event, reason)} // Handle backdrop clicks
        className="border-0"
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
        disableEscapeKeyDown
      >
        <Box
          sx={{ ...style, border: 'none', outline: 'none' }}
          className="w-[90%] max-w-auto  sm:max-w-[500px] md:max-w-[500px] lg:max-w-[500px] px-2 py-4  sm:px-4 sm:py-7 md:px-4 md:py-7  lg:px-4 lg:py-7"
          ref={boxRef}
        >
          <div className="w-full flex justify-center">
            <div className="flex items-center flex-col">
              <h1 className="font-semibold text-lg uppercase text-center text-white mt-3">
                This product is protected by a robust intellectual property portfolio, encompassing pending patents and
                other exclusive rights.
              </h1>
              <Button onClick={() => handleClose()} className="mt-8 hover:bg-gray-100 bg-white text-black">
                <span className="">CONTINUE TO SITE</span>
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Login modal */}

      <FirstLoginModal
        openLoginModal={openLoginModal}
        handleLoginClose={handleLoginClose}
        loginStyle={loginStyle}
        handleCreateClick={handleCreateClick}
        handleOkClick={handleOkClick}
      />

      <div className="w-full  hidden lg:flex justify-between px-20    bg-transparent  my-4 z-30 ">
        <div className="flex justify-between w-1/2  items-center">
          <Link className="cursor-pointer" href="/">
            <Image src="/whiteLogo.svg" alt="Expomore" width={100} height={100} className="  min-w-[130px] h-[40px]" />
          </Link>

          <div>
            <Link href="/">
              <Button id="demo-customized-button" aria-haspopup="true" disableElevation>
                <span className="text-[16px] font-normal text-white normal-case ">Home</span>
              </Button>
            </Link>
          </div>

          <div>
            <Link href="/staticpages/about-us">
              <Button id="demo-customized-button" aria-haspopup="true" disableElevation>
                <span className="text-white normal-case font-normal text-[16px] ">About</span>
              </Button>
            </Link>
          </div>
          <div className="flex space-x-8">
            {/* Products Menu */}
            <div
              className="relative inline-block"
              ref={productMenuRef}
              onMouseLeave={() => handleMouseLeave(setProductMenuOpen, productMenuRef)}
            >
              <button
                className="flex items-center text-white px-4 py-2 bg-transparent rounded"
                onMouseEnter={() => setProductMenuOpen(true)}
              >
                <span className="normal-case  font-normal text-[16px]">Products</span>
                <ChevronDown
                  className={`ml-2 h-5 w-5 text-white transition-transform duration-300 ${
                    productMenuOpen ? 'rotate-180' : 'rotate-0'
                  }`}
                />
              </button>
              <div
                className={`absolute mt-2 w-72 bg-white shadow-lg rounded-lg z-10 ${
                  productMenuOpen ? 'block' : 'hidden'
                }`}
              >
                <div className="flex flex-col">
                  <button
                    onClick={() => {
                      handleLoginOpen('/work');
                    }}
                    className="flex items-center px-4 py-3 hover:bg-gray-100 hover:rounded-[7px]"
                  >
                    <Briefcase className="w-5 h-5" />
                    <span className="ml-3">Work</span>
                  </button>
                  <button
                    onClick={() => {
                      handleLoginOpen('/earnings');
                    }}
                    className="flex items-center px-4 py-3 hover:bg-gray-100"
                  >
                    <CreditCard className="w-5 h-5" />
                    <span className="ml-3">Earnings</span>
                  </button>
                  <button
                    onClick={() => {
                      handleLoginOpen('/topup');
                    }}
                    className="flex items-center px-4 py-3 hover:bg-gray-100"
                  >
                    <Upload className="w-5 h-5" />
                    <span className="ml-3">Topup & Balance</span>
                  </button>
                  <button
                    onClick={() => {
                      handleLoginOpen('/messages');
                    }}
                    className="flex items-center px-4 py-3 hover:bg-gray-100"
                  >
                    <MessageSquareMore className="w-5 h-5" />
                    <span className="ml-3">Messages</span>
                  </button>
                  <button
                    onClick={() => {
                      handleLoginOpen('/callhistory');
                    }}
                    className="flex items-center hover:rounded-[7px] px-4 py-3 hover:bg-gray-100"
                  >
                    <Phone className="w-5 h-5" />
                    <span className="ml-3">Call History</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Resources Menu */}
            <div
              className="relative inline-block"
              ref={resourceMenuRef}
              onMouseLeave={() => handleMouseLeave(setResourceMenuOpen, resourceMenuRef)}
            >
              <button
                className="flex items-center text-white px-4 py-2 bg-transparent rounded"
                onMouseEnter={() => setResourceMenuOpen(true)}
              >
                <span className="normal-case font-normal text-[16px]">Resources</span>
                <ChevronDown
                  className={`ml-2 h-5 w-5 text-white transition-transform duration-300 ${
                    resourceMenuOpen ? 'rotate-180' : 'rotate-0'
                  }`}
                />
              </button>
              <div
                className={`absolute mt-2 w-72 bg-white shadow-lg rounded-lg z-10 ${
                  resourceMenuOpen ? 'block' : 'hidden'
                }`}
              >
                <div className="flex flex-col">
                  <Link className="w-full hover:bg-gray-100" href="/staticpages/resources/contactus">
                    <button className="flex items-center hover:rounded-[7px] px-4 py-3 hover:bg-gray-100">
                      <HelpCircleIcon className="w-5 h-5" />
                      <span className="ml-3">Help And Support</span>
                    </button>
                  </Link>

                  <Link className="w-full hover:bg-gray-100" href="/staticpages/resources/newsroom">
                    <button className="flex items-center px-4 py-3 hover:bg-gray-100">
                      <NewspaperIcon className="w-5 h-5" />
                      <span className="ml-3">Newsroom</span>
                    </button>
                  </Link>
                  <Link className="w-full hover:bg-gray-100" href="/staticpages/investment">
                    <button className="flex items-center px-4 py-3 hover:bg-gray-100">
                      <DollarSign className="w-5 h-5" />
                      <span className="ml-3">Investment</span>
                    </button>
                  </Link>
                  <button className="flex items-center px-4 py-3 hover:bg-gray-100">
                    <ShoppingBag className="w-5 h-5" />
                    <span className="ml-3">Refund Policy</span>
                  </button>
                  <Link className="w-full hover:bg-gray-100" href="/staticpages/mss">
                    <button className="flex items-center px-4 py-3 hover:bg-gray-100">
                      <Lock className="w-5 h-5" />
                      <span className="ml-3">Modern Slavery Statement</span>
                    </button>
                  </Link>
                  <Link className="w-full hover:bg-gray-100" href="/staticpages/termofuse">
                    {' '}
                    <button className="flex items-center px-4 py-3 hover:bg-gray-100">
                      <FileText className="w-5 h-5" />
                      <span className="ml-3">Terms Of Use</span>
                    </button>
                  </Link>
                  <Link className="w-full hover:rounded-[7px] hover:bg-gray-100" href="/staticpages/privacy">
                    {' '}
                    <button className="flex items-center hover:rounded-[7px] px-4 py-3 hover:bg-gray-100">
                      <Shield className="w-5 h-5" />
                      <span className="ml-3">Privacy Policy</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Menu */}
        <div className="flex items-center">
          <div
            className="relative inline-block"
            ref={languageMenuRef}
            onMouseLeave={() => handleMouseLeave(setLanguageMenuOpen, languageMenuRef)}
          >
            <button
              className="flex items-center text-white px-4 py-2 bg-transparent rounded"
              onMouseEnter={() => setLanguageMenuOpen(true)}
            >
              <span className="normal-case">Eng(UK)</span>
              <ChevronDown
                className={`ml-2 h-5 w-5 text-white transition-transform duration-300 ${
                  languageMenuOpen ? 'rotate-180' : 'rotate-0'
                }`}
              />
            </button>
            <div
              className={`absolute mt-2 w-72 bg-white shadow-lg rounded-lg z-10 ${
                languageMenuOpen ? 'block' : 'hidden'
              }`}
            >
              <div className="flex flex-col max-h-[400px] overflow-auto ">
                {languages
                  .slice() // Create a shallow copy of the array to avoid mutating the original array
                  .sort((a: any, b: any) => a.label.localeCompare(b.label)) // Sort alphabetically by label
                  .map((language: any) => (
                    <button
                      key={language.value} // Use a unique key
                      className="flex items-center rounded-[7px] hover:rounded-[7px] px-4 py-3 hover:bg-gray-100"
                    >
                      <span className="ml-3">{language.label}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>

          {!isUserLoggedIn && (
            <>
              <Button
                onClick={handleCreateClick}
                className=" font-bold  text-white normal-case px-6 hover:bg-white hover:text-black "
              >
                Signup
              </Button>
              <div>
                <Button
                  onClick={handleOkClick}
                  className=" font-bold  text-white normal-case px-7 hover:bg-white hover:text-black "
                >
                  Login
                </Button>
              </div>
            </>
          )}
          {isUserLoggedIn && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Tooltip title="Notifications">
                <IconButton
                  // onClick={handleProfileClick}
                  size="small"
                  sx={{ ml: 2 }}
                >
                  <Bell className="text-white h-[20px] w-[20px] " />
                </IconButton>
              </Tooltip>
              <Tooltip title="Account settings">
                <IconButton onClick={handleProfileAvtarClick} size="small" sx={{ ml: 2 }}>
                  <Avatar className="bg-[#191566] capitalize" sx={{ width: 35, height: 35 }}>
                    {user?.Email?.charAt(0)}
                  </Avatar>
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </div>
      </div>
    </>
  );
}
